import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'onlyTime'
})
export class OnlyTimePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    transform(time: string): string|null {
        if(!time) return null;

        let checkDate = Date.parse(`${new Date().toLocaleDateString()} ${time}`);
        return this.datePipe.transform(checkDate,'h:mm a');
    }
}
